import { baseDefaultContextProps } from '../../constants/props';
import { routes } from '../../constants/routes';
import { searchObject } from '../../data/api/crmV3Api';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../../data/api/playbooksApi';
export const defaultPlaybooksProps = Object.assign({}, baseDefaultContextProps, {
  apiWrapper: {
    playbooks: {
      fetchPlaybooks,
      fetchRecommendedPlaybooks
    },
    searchObject
  },
  featureTipsLink: '',
  reconnectRoute: routes.reconnect
});